import { OptionsClass } from "@/domain/entities/MainApp";

export const STATUS_PICKUP_SCHEDULE: OptionsClass[] = [
  new OptionsClass({
    name: "SHPCRT",
    value: "SHPCRT"
  }),
  new OptionsClass({
    name: "CRRSRC",
    value: "CRRSRC"
  }),
  new OptionsClass({
    name: "pickupV2.list.filter.statusList.searchingCourier",
    value: "CRRNFD,SHPCRT,SHPSCD,CRRSRC"
  }),
  new OptionsClass({
    name: "pickupV2.list.filter.statusList.courierAssigned",
    value: "CRROTW"
  }),
  new OptionsClass({
    name: "pickupV2.list.filter.statusList.packageMerged",
    value: "SHPMRG"
  }),
  new OptionsClass({
    name: "pickupV2.list.filter.statusList.packagePickedUp",
    value: "CRRPIC"
  }),
  new OptionsClass({
    name: "pickupV2.list.filter.statusList.completed",
    value: "CRRDON"
  }),
  new OptionsClass({
    name: "pickupV2.list.filter.statusList.cancelledByCourier",
    value: "CRRCNC"
  }),
  new OptionsClass({
    name: "pickupV2.list.filter.statusList.cancelledByClient",
    value: "CSTCNC"
  }),
  new OptionsClass({
    name: "pickupV2.list.filter.statusList.cancelledByAdmin",
    value: "ADMCNC"
  })
];
